import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/ma/test/page',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/ma/test/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/ma/test/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/ma/test/submit',
    method: 'post',
    data: row
  })
}

